import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, QUERY_KEYS } from '../queryClient';

// Config
import { crudConfig } from '../../../conf/criteriaResources';

export const getQueryKey = getQueryKeyBase.bind(null, QUERY_KEYS.CRITERIA_RESOURCE);

export const useGetCriteriaResourceById = ({ sessionToken, resourceId, queryOptions = {} }) => {
    const Client = apiClient(crudConfig);
    const query = useQuery({
        queryKey: getQueryKey(resourceId),
        queryFn: () => Client.fetchOne(sessionToken, resourceId),
        onSuccess: (data) => {
            // console.log('Success', data);
        },
        onError: (data) => {
            console.log('Error', data);
        },
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        enabled: typeof resourceId !== 'undefined',
        ...queryOptions
    });

    return {
        data: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
        refetch: async () => {
            await query.refetch();
        }
    };
};
